/**
 * Created by fers on 25.07.16.
 */

import Relay from 'react-relay';
import PropTypes from 'prop-types';

interface MarkAsReadMutationProps {
    flow_id: string;
    organisation_id: string;
    pause: boolean;
}

export default class MarkAsReadMutation extends Relay.Mutation<MarkAsReadMutationProps> {
    static propTypes = {
        announcement_id: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
    };

    getMutation() {
        return Relay.QL`mutation {markAsRead}`;
    }

    getVariables() {
        return {
            announcement_id: this.props.announcement_id,
            type: this.props.type,
        };
    }

    getFatQuery() {
        return Relay.QL`
          fragment on MarkAsReadPayload {
              clientMutationId,
              updatedNode {
                  id,
              }
          }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [
                this.getFatQuery()
            ],
        }];
    }
}
